import React, {useState} from 'react';
import { setEntranceUrl, getEntranceUrl } from '@/utils/localStorage';

function useEntryPath() {
  // 登录入口
  const [entryPath, setEntryPath] = useState('');

  // 保存登录入口
  function saveEntryPath() {
    const {
      href,
      pathname,
      search
    } = window.location;
    if (href.toLowerCase().indexOf('login') > -1) {
      const entryPath = pathname + search;
      setEntryPath(entryPath);
      setEntranceUrl(entryPath);
    }
  }

  // 获取登录入口
  function getEntryPath() {
    return entryPath || getEntranceUrl();
  }

  return { entryPath, saveEntryPath, getEntryPath }
}

export default useEntryPath;